import { Box, SpacerNew, TextNew } from '@jfs/ui-new'
import { useEffect, useState } from 'react'
import { DualActionButtonComp } from '../../../../components/DualActionButtonComp'
import { bulkEntityStringConstants } from '../../../../utils/constants'
import { SelectParentEntityList } from '../../Onboarding/CreateEntity/SelectParentEntityList'
import { flexMapperWithIndex } from './Fixtures'
import { styles } from './styles'

interface ReviewUploadedFileInterface {
  onSubmitPress: () => void
  onUploadNewFilePress: () => void
  getUploadedExcelFileData: () => void
  returnExcelFileName: string
  type: 'bulkUpload' | 'tid'
}

const ReviewUploadedFile = ({
  onSubmitPress,
  onUploadNewFilePress,
  getUploadedExcelFileData,
  returnExcelFileName,
  type,
}: ReviewUploadedFileInterface) => {
  const [excelFormattedData, updateExcelFormattedData] = useState([])
  const [headerArray, updateHeaderArray] = useState([])

  useEffect(() => {
    const data: Array<any> = getUploadedExcelFileData()
    const uniqueKeys: { [key: string]: boolean } = {}

    // Loop through each object and gather the keys
    data.forEach((item) => {
      Object.keys(item).forEach((key) => {
        uniqueKeys[key] = true // Use the key as a property
      })
    })

    // Convert the unique keys into an array of objects
    const mapData = Object.keys(uniqueKeys).map((key) => ({ title: key }))
    updateHeaderArray(mapData)
    updateExcelFormattedData(data)
  }, [getUploadedExcelFileData, updateExcelFormattedData])

  return (
    <Box height={'100%'}>
      <Box {...styles.boxContainer} flex={1}>
        <TextNew title={bulkEntityStringConstants[type].reviewUploadedFile} {...styles.headerTitle} />
        <SpacerNew size={2} />
        <TextNew
          title={`${bulkEntityStringConstants[type].showPreview}${returnExcelFileName ?? ''}`}
          {...styles.previewText}
        />
        <SpacerNew size={20} />
        <Box overflow="auto" h={476} marginTop={16}>
          <SelectParentEntityList
            title={''}
            hide={false}
            data={excelFormattedData}
            headerTitles={headerArray}
            rowDataMapperKeys={headerArray}
            columnFlexMapper={flexMapperWithIndex}
          />
        </Box>
      </Box>
      <DualActionButtonComp
        isOutlineButtonVisible={true}
        isColoredButtonVisible={true}
        isValid={true}
        outlineButtonTitle={bulkEntityStringConstants[type].uploadNewFile}
        coloredButtonText={bulkEntityStringConstants[type].submitFile}
        onColoredButtonPress={onSubmitPress}
        onOutlineButtonPress={onUploadNewFilePress}
      />
    </Box>
  )
}

export default ReviewUploadedFile
